import { IDropdownOption } from "components/common/HighButton";
import { IHierarchyProperty } from "components/hierarchypage/HierarchyProperties";
import { IAppSettings } from "contexts/appsettings/interface";
import { eApplicationPermission, eHierarchyLevel } from "../../functions/api/enums";
import { tagCheck } from "./tagCheck";

const defaultDownloadOptions: IDropdownOption[] = [
  { label: "Standard notes", selected: true, propertiesKey: "Notes" },
  { label: "Programmer notes", selected: true, propertiesKey: "ProgrammerNotes" },
  { label: "SAP reference", selected: true, propertiesKey: "SapReference" },
  { label: "Program name", selected: true, propertiesKey: "ProgramName" },
  { label: "Output name", selected: true, propertiesKey: "OutputName" },
];

export const CorporateProps: IHierarchyProperty[] = [
  {
    key: "domainList",
    value: "",
    type: "string",
    label: "Available domains",
    /**
     * Validate the `domainList` value using a comparator object.
     *
     * @param _ - Unused first parameter kept for signature compatibility.
     * @param c - Comparator object containing the value to validate.
     * @returns A promise resolving to the validation result object.
     */
    validCondition: async (_, c) => ({
      success: true,
      data: {
        valid: c.value.match(/^[A-Z,]+$/) !== null,
        validationText:
          c.value.match(/^[A-Z,]+$/) === null
            ? "Domains must be uppercase and separated by commas"
            : "",
      },
    }),
  },
];

const TAProps: IHierarchyProperty[] = [
  {
    key: "taPrefix",
    value: "",
    type: "hierarchyTag",
    label: "TA prefix",
    mandatory: true,
    validCondition: tagCheck(
      eHierarchyLevel.TA,
      "TA prefix",
      "Prefix must be 2 or 3 upper case characters",
    ),
  },
];
const ProjectProps: IHierarchyProperty[] = [
  {
    key: "projectCode",
    value: "D",
    type: "hierarchyTag",
    label: "Project code",
    mandatory: true,
    validCondition: tagCheck(
      eHierarchyLevel.Project,
      "project code",
      "Project code must begin with D followed by 3 digits",
    ),
  },
];
const StudyProps: IHierarchyProperty[] = [
  {
    key: "dNumber",
    value: "",
    type: "hierarchyTag",
    label: "D number",
    mandatory: true,
    validCondition: tagCheck(
      eHierarchyLevel.Study,
      "D number",
      "Field should be D followed by 10 characters",
    ),
  },
  { key: "description", value: "", type: "textarea", label: "Description" },
  { key: "phase", value: "", type: "string", label: "Phase" },
  {
    key: "status",
    value: "Not started",
    type: "select",
    label: "Status",
    allowedValues: ["Not started", "In progress", "Completed"],
  },
  {
    key: "studyStandardsDate",
    value: new Date(Date()).toISOString().slice(0, 11) + "00:00:00.000Z",
    type: "datetime-local",
    label: "Standards date",
    futureBad: true,
    blankBad: true,
    permissionRequired: [eApplicationPermission.AllowStudyStandardDateEdit],
  },
];
const ReportProps: IHierarchyProperty[] = [
  { key: "description", value: "", type: "textarea", label: "Description" },
  { key: "reportType", value: "", type: "string", label: "Report type" },
];

export const defaultSettings: IAppSettings = {
  appSettingsLoaded: true,
  applicationPermissions: [],
  backEndUrl: "http://localhost:5218/",
  backEndVersion: "0.0.0",
  colWidthMod: 4.4,
  crystalUrl: "https://localhost:5000/",
  defaultColumnWidth: 30,
  defaultDownloadOptions,
  defaultLevelProperties: {
    Corporate: CorporateProps,
    TA: TAProps,
    Project: ProjectProps,
    Study: StudyProps,
    Report: ReportProps,
  },
  defaultTableStyle: { fontFamily: "Courier New", fontSize: "9pt", fontWeight: 500 },
  displayName: "DEFAULT NoAuth",
  domain: "astrazeneca.net",
  figureSettings: {
    figureTypeSettings: [],
    figureProperties: [],
    figureAxisSettings: [],
    figureLegendSettings: [],
    figureRegressionLineSettings: [],
  },
  helpLinks: [],
  isAdmin: false,
  maintenanceMessage: "",
  maintenanceMode: false,
  prid: "no-prid",
  styles: [],
  annotationComparatorTypes: [],
  userId: 0,
};
